import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Book, Page } from 'components/Layout';
import DateRangePickerForm, { DateRange } from 'components/Input/components/DateRangePickerForm';
import moment from 'moment';
import { LocationInspectionDataResponse } from 'types/reporting.type';
import LrGrid from 'components/LrGrid/components/Grid';
import { columnDefs } from './GridDefs';
import { fetchInspectionLocationData } from 'services/reporting';
import { GridApi } from 'ag-grid-enterprise';
import LrButton from 'components/LrButton/components/Button';
import { updateLocationInspection } from 'services/location';
import LrToastNotify from 'components/LrToastNotify';

const LocationInspectionData: React.FunctionComponent = (props) => {
    const [inspectionData, setInspectionData] = useState<LocationInspectionDataResponse[]>();
    const [saveInspectionsConfirm, setSaveInspectionsConfirm] = useState<string>();
    const [gridApi, setGridApi] = useState<GridApi>();
    const defaultStart = moment().subtract(1, 'week').startOf('week');
    const defaultEnd = moment().subtract(1, 'week').endOf('week');

    const fetchOrderInspectionData = async (values: DateRange) => {
        const data = await fetchInspectionLocationData(values);
        setInspectionData(data);
    };

    useEffect(() => {
        fetchOrderInspectionData({ startDate: defaultStart, endDate: defaultEnd });
    }, []);

    const renderDataGrid = (height: string) => (
        <LrGrid
            gridClassName="ag-theme-balham"
            columnDefs={columnDefs}
            rowData={inspectionData}
            hideStatusBar
            sizeToFit
            rowSelection={'multiple'}
            suppressRowClickSelection={true}
            height={height}
            setGridApi={setGridApi}
        />
    );

    const handelCreateInspectionsClick = async () => {
        const selected = gridApi && gridApi.getSelectedRows();
        if (selected) {
            const allCreated = await Promise.all(
                selected.map(async (row) => {
                    const created = await updateLocationInspection(row.locationId, {
                        physicalLocationId: row.physicalLocationId,
                        requestedDate: moment().format('MM/DD/YYYY'),
                    });
                    return created;
                })
            ).catch(() => setSaveInspectionsConfirm('Error Saving Inspections'));
            if (allCreated) {
                setSaveInspectionsConfirm(
                    `Successfully created Inspections for ${allCreated.filter((c) => !!c.id).length} locations`
                );
            }
        }
    };

    const renderActions = () => {
        return (
            <Grid container spacing={2} style={{ margin: 0, width: '100%' }}>
                <Grid>
                    <LrButton onClick={handelCreateInspectionsClick} lrType="secondary">
                        Create Inspections For Selected
                    </LrButton>
                </Grid>
            </Grid>
        );
    };

    return (
        <>
            <Book actions={renderActions()}>
                <>
                    <Grid container>
                        <Grid xs={12}>
                            <DateRangePickerForm
                                onSubmit={fetchOrderInspectionData}
                                submitText={'Fetch'}
                                defaultStart={defaultStart}
                                defaultEnd={defaultEnd}
                            />
                        </Grid>
                        <Grid xs={12}>{renderDataGrid('700px')}</Grid>
                    </Grid>
                </>
            </Book>
            <LrToastNotify open={!!saveInspectionsConfirm} onClose={() => setSaveInspectionsConfirm('')}>
                {saveInspectionsConfirm}
            </LrToastNotify>
        </>
    );
};

export default LocationInspectionData;
